import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const declineMedicalDentalTableStyles = makeStyles((theme) => ({
	declineMedicalDentalTable: {
		'& .header-cell': {
			padding: '1rem .5rem',
			border: 'none !important',
		},
		'& .main': {
			'&-row': {

				'&:nth-child(odd)': {
					background: tcsmColors.greySix,
				},
				'&-alert': {
					background: '#EFD6D6 !important',
				},
				'&.grey-row': {
					'&-dark': {
						backgroundColor: tcsmColors.greyFour,
					},
					'&-medium': {
						backgroundColor: tcsmColors.greyFive,
					},
				},
				[theme.breakpoints.up('lg')]: {
					display: 'flex',
				},
				'&-cell': {
					[theme.breakpoints.up('lg')]: {
						width: '50%',
					},

					'& + .main-row-cell': {
						[theme.breakpoints.up('lg')]: {
							borderLeft: `1px solid ${tcsmColors.greyFour}`,
						},
					},
					'&-rates':{
						[theme.breakpoints.up('lg')]: {
							textAlign: 'center',
						},
					},
					'& .internal-row': {
						[theme.breakpoints.up('lg')]: {
							display: 'table',
							tableLayout: 'fixed',
							width: '100%',
							maxWidth: '100%',
						},
						'&-cell': {
							'&-alert': {
								display: 'flex',
								marginRight: theme.spacing(.5),
								'&-text': {
									color: tcsmColors.red,
									marginLeft: theme.spacing(.5),
								},
							},
							[theme.breakpoints.up('lg')]: {
								verticalAlign: 'bottom',
								display: 'table-cell',
							},

							padding: '1rem .5rem',


							'&-description': {
								[theme.breakpoints.up('lg')]: {
									display: 'flex',
								},
							},
							'&-lg': {
								width: '60%',
							},
							'&-sm': {
								width: '10%',
							},
						},
					},
				},
			},


		},
		'&-header-row': {
			'&-cell': {
				width: '50%',
			},
		},
	},

}));

